import { t } from 'i18next';
import * as yup from 'yup';

export const customizationSchema = () =>
  yup.object({
    shippingLocation: yup.object().label(t('labelShippingLocation')).nullable(),
    salesLocation: yup.object().label(t('labelSalesLocation')).nullable(),
    shipmentType: yup.object().label(t('labelShipmentType')).nullable(),
    customerBillTo: yup.object().label(t('labelCustomerBillTo')).nullable(),
    project: yup.object().label(t('labelProject')).nullable(),
  });
